import { makeAutoObservable } from "mobx";
import { ServiceMetadata, TariffMetadata } from "../../../shared/src/Types/Types.ts";
import { RootStore } from "./RootStore.ts";

export class ServiceStore {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this);
    }

    newService: ServiceMetadata = {
        backgroundLink: "",
        logoLink: "",
        title: "",
        description: "",
        tariffs_metadatas: [],
    };

    setBackgroundLink(backgroundLink: string) {
        this.newService.backgroundLink = backgroundLink;
    }

    setLogoLink(logoLink: string) {
        this.newService.logoLink = logoLink;
    }

    setServiceName(name: string) {
        this.newService.title = name;
    }

    setServiceDescription(description: string) {
        this.newService.description = description;
    }

    addTariffMetadata(tariffMetadata: TariffMetadata) {
        this.newService.tariffs_metadatas.push(tariffMetadata);
    }
}
